import { defineMessages } from 'react-intl';

export default defineMessages({
  companyList: {
    id: 'company.list',
    defaultMessage: 'Company List',
  },
  inputPlaceholder: {
    id: 'company.search.placeholder',
    defaultMessage: 'Company Name',
  },
  btnRegister: {
    id: 'company.btn.registerNewCompany',
    defaultMessage: 'Register New Company',
  },
  no: {
    id: 'company.table.label.no',
    defaultMessage: 'No',
  },
  companyId: {
    id: 'company.table.label.companyId',
    defaultMessage: 'Company ID',
  },
  companyName: {
    id: 'company.table.label.companyName',
    defaultMessage: 'Company Name',
  },
  companyEmail: {
    id: 'company.table.label.companyEmail',
    defaultMessage: 'Company Email',
  },
  companyRole: {
    id: 'company.table.label.companyRole',
    defaultMessage: 'Company Role',
  },
  action: {
    id: 'company.table.label.action',
    defaultMessage: 'Action',
  },
  viewDetail: {
    id: 'company.table.value.view_details',
    defaultMessage: 'View Detail',
  },
});
